export const enum PROGRAMME {
  MPHIL_2 = 'MPHIL_2',
  PHD_3 = 'PHD_3',
  PHD_4 = 'PHD_4',
}

export const enum QUALIFICATION_CHECK_ITEM {
  GENERAL = 'GENERAL',
  ENGLISH = 'ENGLISH',
}
